import { externalLinks } from 'src/externalLinks';
import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Group, GroupMembership } from './_types';

// Readonly fields that should not be sent to the API
const readOnlyFields = [
  'id',
  'image_url',
  'group_resource_tags',
  'video_tags',
  'leaderboard_tab',
  'all_leaderboards',
  'totals_stats',
  'show_measurements',
  'group_admins',
  'leaderboard',
  'premium_price',
  'premium',
  'original_image_url',
  'cached_slug',
  'member_count',
  'owner',
  'links',
  'user_id',
  'wordpress_url',
  'workout_plan_order',
  'payment_options',
  'created_at',
  'updated_at',
  'group_link_id',
];

export const normalizeGroup = (group: any): Group => {
  const camelizedGroup = camelcaseKeys(group, { deep: true });

  // Handle specific fields that might need custom normalization
  return camelizedGroup as Group;
};

export const denormalizeGroup = (group: Group): any => {
  const decamelizedGroup = decamelizeKeys(group, { deep: true });

  // Remove id from tabs as it's not permitted by Rails
  if (decamelizedGroup.tabs) {
     
    decamelizedGroup.tabs = decamelizedGroup.tabs.map(({ id, ...tab }) => tab);
  }

  removeReadOnlyFields(decamelizedGroup, readOnlyFields);

  return decamelizedGroup;
};

export const normalizeGroupMembership = (membership: any): GroupMembership => {
  const camelizedMembership = camelcaseKeys(membership, { deep: true });

  // Handle specific fields that might need custom normalization
  return {
    ...camelizedMembership,
  } as GroupMembership;
};

export const normalizeMyGroups = (g: any): Group => {
  const cg = camelcaseKeys(g, { deep: true }) as Group;
  return {
    ...cg,
    link: externalLinks.viewGroup(cg.cachedSlug, cg.id),
  };
};